import React from 'react'

export const ProjectLayout = () => {
  return <div>ProjectLayout</div>
}
